import { render } from "./AssetLibraryDialog.vue?vue&type=template&id=e6b6c452&ts=true"
import script from "./AssetLibraryDialog.vue?vue&type=script&lang=ts"
export * from "./AssetLibraryDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.3.4_webpack@5.99.6_esbuild@0.25.3_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__